<template>
    <div class="login_content" :style="{backgroundImage: 'url(' + bgimg + ')'}">
        <div class="login_box">
            <div class="login_clear clear">
                <div class="register_logo"><img :src="logoimg" alt="logo" /></div>
                <div class="register_content">
                    <div class="register_title"><h2>完善信息</h2></div>
                    <div class="register_list">
                        <Form ref="passwordValidate" :model="passwordValidate" :rules="passwordRule">
                            <FormItem prop="passwords">
                                <Input type="password" :minlength="6" :maxlength="20" v-model="passwordValidate.passwords" placeholder="设置密码 (6-20位，英文、符号)" />
                            </FormItem>
                            <FormItem prop="passwordcheck">
                                <Input type="password" :minlength="6" :maxlength="20" v-model="passwordValidate.passwordcheck" placeholder="确认密码" />
                            </FormItem>
                            <FormItem prop="companyname">
                                <Input type="text" v-model="passwordValidate.companyname" placeholder="公司名称" />
                            </FormItem>
                            <FormItem prop="contacts">
                                <Input type="text" v-model="passwordValidate.contacts" placeholder="联系人" />
                            </FormItem>
                            <FormItem prop="phone">
                                <Input type="text"v-model="passwordValidate.phone" :maxlength="11" placeholder="电话号码" />
                            </FormItem>
                            <FormItem prop="accounts">
                                <Input type="text" disabled v-model="passwordValidate.accounts" placeholder="登录帐号" />
                            </FormItem>
                            <FormItem prop="protocol">
                                <Checkbox v-model="passwordValidate.protocol" size="large"></Checkbox>
                                <span class="protocol">同意<b @click="openAgreementClick(1)">{{protocoltit1}}</b>与<b @click="openAgreementClick(2)">{{protocoltit2}}</b></span>
                            </FormItem>
                            <FormItem>
                                <Button class="register_submit" type="warning" long @click="handleSubmit('passwordValidate')">完成</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <div class="register_bottom clear">
                        <div class="register_bottom_l"><span>已有账号，去<router-link :to="{name: 'Login'}">登录</router-link></span></div>
                    </div>
                </div>
                <div class="login_copyright_content"><span>{{tcpip}}</span></div>
            </div>
        </div>
        <!-- 漂浮客服 -->
        <ServerFixed></ServerFixed>
        <!-- 规则弹窗 -->
        <Agreement :agreementnews="news" :agreementShow="agreementShow" @agreementClear="agreementClear"></Agreement>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import qs from 'Qs'
import ServerFixed from '@/components/component/serverfixed.vue'
import Agreement from '@/components/component/popup/agreement.vue'

export default {
    components: {ServerFixed, Agreement},
    data () {
        const passwordsValidator = (rule, value, callback) => { // 密码验证
            var reg = new RegExp("[\\u4E00-\\u9FFF]+","g")
            if (value === '' || value.length < 6 || value.length > 20 || reg.test(value)) {
                if (value === '') {
                    callback(new Error('密码不可为空，请填写'))
                } else {
                    callback(new Error('请输入6-20位英文、数字、符号（如$、*、%...）'))
                }
                callback(new Error(''))
            } else {
                if (this.passwordValidate.passwordcheck != '') {
                    // 对第二个密码框单独验证
                    this.$refs.passwordValidate.validateField('passwordcheck')
                }
                callback()
            }
        }
        const passwordcheckValidator = (rule, value, callback) => { // 确认密码
            if (value === '') {
                callback(new Error('确认密码不可为空，请填写'));
            } else if (value !== this.passwordValidate.passwords) {
                callback(new Error('两次输入的密码不一致请重新输入'));
            } else {
                callback();
            }
        }
        return {
            logoimg: '', // logo
            bgimg: '', // 背景图
            tcpip: '', // 备案信息
            agreementShow: false,
            passwordValidate: { // 表单内容
                passwords: '', // 密码
                passwordcheck: '', // 确认密码
                companyname: '', // 公司名称
                contacts: '', // 联系人
                phone: '', // 手机号
                accounts: '', // 登录帐号
                protocol: false, // 是否同意协议
                invitationcode: '', // 邀请码
            },
            passwordRule: { // 表单验证
                passwords: [ // 密码
                    {validator: passwordsValidator, trigger: 'blur'}
                ],
                passwordcheck: [ // 确认密码
                    { validator: passwordcheckValidator, trigger: 'blur' }
                ],
                companyname: [ // 公司名称
                    { required: true, message: '公司名称不可为空', trigger: 'blur' }
                ],
                contacts: [ // 联系人
                    { required: true, message: '联系人不可为空', trigger: 'blur' }
                ],
                phone: [ // 手机号
                    { required: true, message: '手机号不可为空', trigger: 'blur' }
                ]
            },
            protocoltit1: '',
            protocolcon1: '',
            protocoltit2: '',
            protocolcon2: '',
            news: '',
        }
    },
    methods: {
        getInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.logininfo + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    this.logoimg = response.data.msg.baseinfo.orderinglogo
                    this.bgimg = response.data.msg.backgroundlist[0]
                    this.tcpip = response.data.msg.tcpip
                    this.protocoltit1 = response.data.msg.newslist[0].title
                    this.protocolcon1 = response.data.msg.newslist[0].content
                    this.protocoltit2 = response.data.msg.newslist[1].title
                    this.protocolcon2 = response.data.msg.newslist[1].content
                    if (response.data.msg.baseinfo.is_selfreg == 0) {
                        this.$Message.error('不允许自主注册，请联系客服人员')
                        this.$router.push('/Login')
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        submitInfo () {
            let data = {
                i_account: this.passwordValidate.accounts,
                i_password: this.passwordValidate.passwords,
                i_repassword: this.passwordValidate.passwordcheck,
                i_name: this.passwordValidate.companyname,
                i_linkman: this.passwordValidate.contacts,
                i_contactphone: this.passwordValidate.phone,
                i_invitecode: this.passwordValidate.invitationcode
            }
            axios({
                url: this.getWebsite() + api.evpi + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    // console.log(response.data.msg)
                    if (!response.data.error) { // 登录成功
                        this.$router.push({
                            name: 'Result',
                            params: {
                                uid: response.data.msg.customerinfo.uid
                            }
                        })
                    } else {
                        this.$Message.error(response.data.msg)
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        handleSubmit (name) { // 点击登录按钮
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (!this.passwordValidate.protocol) {
                        this.$Message.error('请阅读《' + this.protocoltit1 + '》与《' + this.protocoltit2 + '》,同意后才可完成注册');
                    } else {
                        this.submitInfo()
                    }
                }
            })
        },
        openAgreementClick (sign) { // 显示协议弹窗
            sign == 1 ? this.news = this.protocolcon1 : this.news = this.protocolcon2
            this.agreementShow = true
        },
        agreementClear (e) { // 关闭协议弹窗
            this.agreementShow = false
            if (e == 'ok') this.passwordValidate.protocol = true
        }
    },
    created () {
        this.getInfo()
    },
    mounted () {
        this.passwordValidate.accounts = this.$route.params.phone
        if (this.$route.params.invitationcode != undefined || this.$route.params.invitationcode != '') this.passwordValidate.invitationcode = this.$route.params.invitationcode
    }
}
</script>

<style scoped>

.login_box {
    height: 750px;
    margin: -375px 0 0 -450px;
}

.protocol {
    font-size: 14px;
}

.protocol b {
    color: #FF8000;
    font-weight: normal;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/views/login/evpi.vue